import React from "react";
import { lang } from "../lang";

// Component for todo list control buttons
function TodoListControls({ todoDispatch }) {
  return (
    <div className="todo-controls">
      <button onClick={() => todoDispatch({ type: "ADD_LIST" })}>
        {lang.app.addList}
      </button>
      <button onClick={() => todoDispatch({ type: "ADD_BOOK_LIST" })}>
        {lang.app.addBookList}
      </button>
    </div>
  );
}

export default TodoListControls;
